<mat-toolbar color="primary" class="toolbar-style" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
  @if (isClickFromTable) {
    <div>
      <button mat-icon-button class="toolBarButton" (click)="returnToTable()">
        <mat-icon [svgIcon]="res.svgName('ArrowBack-Image')"></mat-icon>
      </button>
    </div>
  }
  <!--span class="toolbar-header">{{ res.get('Documents-Title') }}</span-->
  <mat-form-field class="dtSelection">
    <mat-select #dtSelection [(ngModel)]="selected" disableOptionCentering>
      @for (docType of this.currentDocumentTypes; track docType.filter) {
        <mat-option [value]="docType"> {{ docType.displayText }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <span class="toolbar-spacer"></span>

  <button mat-icon-button class="toolBarButton" (click)="this.frame.lib.closeBottomSheet()">
    <mat-icon [svgIcon]="res.svgName('ExpandMore-Image')"></mat-icon>
  </button>
</mat-toolbar>

<div id="documentList" [ngStyle]="{ overflow: 'auto', display: activeObjectInfo ? 'block' : 'none' }">
  <ng-container #dynamic></ng-container>
</div>

<div class="noDataPlaceHolder" [ngStyle]="{ display: !activeObjectInfo ? 'block' : 'none' }">
  &lt;{{ res.get('Documents-NoData') }}&gt;
</div>
